import React from 'react'
import s from './styles/StepDescription.module.scss'

const StepDescription = ({ value, onChange }) => {
	const length = value?.length || 0

	return (
		<div className={s.root}>
			<header className={s.header}>
				<h2 className={s.header__title}>Assignment Description</h2>
				<p className={s.header__subtitle}>
					Provide clear guidance for students on what to do
				</p>
			</header>

			<section className={s.box}>
				<textarea
					className={s.textarea}
					value={value}
					onChange={e => onChange?.(e.target.value)}
					placeholder={`Examples:
- What should students submit?
- What are the key requirements?
- What resources should they use?
- What are you looking for in their work?`}
				/>

				<div className={s.counter}>{length} characters</div>
			</section>
		</div>
	)
}

export default StepDescription
